export const emailConfirmationQuestionData = {
  title: 'Do you want a confirmation email of your report?',
  key: 'emailConfirmation',
  options: [
    {
      labelText: 'Yes',
    },
    {
      labelText: 'No',
    },
  ],
};

export const additionalLocationDetails = {
  id: 'additionalLocationDetails',
  errorPath: 'additionalLocationDetails',
  labelText: 'Do you have any more information about the location (optional)?',
  description:
    'For example, is the vehicle close to a shop, a road junction or other landmark?',
  maxLength: 500,
};
